import type { ForecastGroup, ForecastItem } from '@/types/Forecast';

export function pickCurrentGroup(groups: ForecastGroup[], nowMs = Date.now()): ForecastGroup | null {
  if (!groups?.length) return null;

  const sortedGroups = [...groups].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  const found = sortedGroups.reverse().find((group) => new Date(group.timestamp).getTime() <= nowMs);

  return found ?? null;
}

export function pickHorizonItems(
  group: ForecastGroup | null,
  horizons: number[] = [3600, 7200, 10800, 14400],
): ForecastItem[] {
  if (!group) return [];

  return horizons
    .map((seconds) => group.items.find((item) => item.horizon === seconds))
    .filter((item): item is ForecastItem => item !== null && item !== undefined);
}
